import React from 'react';

const LegalNotice = () => (
  <div
    style={{
      maxWidth: 900,
      margin: '2rem auto',
      paddingTop: 'calc(env(safe-area-inset-top, 16px) + 80px)',
      fontFamily: 'Arial, sans-serif',
      paddingLeft: '16px',
      paddingRight: '16px',
    }}
  >
          <h1 style={{ color: '#e52e71' }}>Aviso Legal</h1>
          <div style={{ marginBottom: '2rem' }}>
            <h2>1. Información de la Empresa</h2>
            <p>Este sitio web es operado por <strong>FIEFIA SL</strong> (la "Empresa").</p>
            <ul>
              <li><strong>Razón Social:</strong> FIEFIA SL</li>
              <li><strong>CIF:</strong> B23815418</li>
              <li><strong>Domicilio Social:</strong> PASEO ERMITA DEL SANTO, 40 - 1, 28011 MADRID, Madrid</li>
              <li><strong>Sitio web:</strong> fotopacasa.es</li>
              <li><strong>Servicio:</strong> Servicio de procesamiento de fotos de identificación online</li>
              <li>La Empresa proporciona servicios de procesamiento de fotos digitales para documentos oficiales como tarjetas de identidad, pasaportes y permisos de conducir.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>2. Propiedad Intelectual</h2>
            <ul>
              <li>Todo el contenido de este sitio web, incluyendo texto, gráficos, logotipos, imágenes y software, es propiedad de FIEFIA SL o de sus proveedores de contenido y está protegido por las leyes de derechos de autor españolas e internacionales.</li>
              <li>No puedes reproducir, distribuir, modificar o crear obras derivadas de ningún contenido de este sitio web sin permiso explícito por escrito.</li>
              <li>El uso no autorizado de cualquier material puede violar las leyes de derechos de autor, marcas registradas y otras leyes.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>3. Limitación de Responsabilidad</h2>
            <ul>
              <li>La Empresa se esfuerza por garantizar la exactitud de la información en este sitio web, pero no garantiza su integridad o corrección.</li>
              <li>La Empresa no es responsable de ningún daño directo, indirecto, incidental o consecuente que surja del uso o la incapacidad de usar este sitio web o sus servicios.</li>
              <li>La Empresa no garantiza que el sitio web esté libre de interrupciones, errores o virus u otros componentes dañinos.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>4. Contenido del Usuario</h2>
            <ul>
              <li>Al subir fotos a nuestro servicio, otorgas a FIEFIA SL una licencia para procesar, almacenar y usar tus imágenes únicamente con el fin de proporcionar el servicio solicitado.</li>
              <li>Conservas todos los derechos sobre tus imágenes subidas.</li>
              <li>Eres responsable de asegurarte de que tienes el derecho de usar y subir las imágenes que proporcionas.</li>
              <li>Las imágenes procesadas se eliminan automáticamente de nuestros servidores después de un período razonable según se especifica en nuestra Política de Privacidad.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>5. Servicios de Terceros</h2>
            <ul>
              <li>Este sitio web puede contener enlaces a sitios web o servicios de terceros que no son propiedad ni están controlados por FIEFIA SL.</li>
              <li>No tenemos control sobre, y no asumimos responsabilidad por, el contenido, las políticas de privacidad o las prácticas de cualquier sitio web o servicio de terceros.</li>
              <li>Reconoces y aceptas que FIEFIA SL no será responsable de ningún daño o pérdida causada por tu uso de cualquier servicio de terceros.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>6. Ley Aplicable</h2>
            <ul>
              <li>Este Aviso Legal se rige por las leyes de España.</li>
              <li>Cualquier disputa que surja de o esté relacionada con este sitio web estará sujeta a la jurisdicción exclusiva de los tribunales de España.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>7. Información de Contacto</h2>
            <p>Para cualquier pregunta o consulta sobre este Aviso Legal, por favor contáctanos en:</p>
            <ul>
              <li><strong>Email:</strong> <a href="mailto:ayuda.fotopacasa@fiefia.es">ayuda.fotopacasa@fiefia.es</a></li>
            </ul>
          </div>
  </div>
);

export default LegalNotice;
